export default __webpack_public_path__ + "static/media/tech-blog-image.bd49ad23.png";